import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import MailIcon from '@material-ui/icons/Mail';
import { Link } from "react-router-dom";
import { 
    Container, 
    Box,
    Drawer,
    AppBar,
    Toolbar,
    List,
    CssBaseline,
    Typography,
    Divider,
    IconButton,
    ListItem,
    ListItemIcon,
    ListItemText,
    Collapse, 
} from '@material-ui/core';
import { Add, Adjust, ChevronRightOutlined, ExpandLess, ExpandLessRounded, ExpandMore, ExpandMoreRounded, FiberManualRecordRounded, Star, StarBorder } from '@material-ui/icons';

const drawerWidth = 260;

const styles = theme => ({
    root: {
        display: 'flex',
        width: "100%"
    },
    appBar: {
        // zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginLeft: 12,
        marginRight: 36,
    },
    hide: {
        display: 'none',
    },
    drawer: {
        zIndex: theme.zIndex.appBar - 1,
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
    },
    drawerOpen: {
        position: 'sticky',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerClose: {
        position: 'sticky',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden',
        width: theme.spacing(7) + 1,
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9) + 1,
        },
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    content: {
        flexGrow: 1,
        width: '100%',
        padding: theme.spacing(3),
        overflow: 'auto',
    },
    nested: {
        paddingLeft: theme.spacing(10),
      },
});

class SideBar extends React.Component {
  state = {
    open: true,
    openSub: ""
  };

  handleDrawer = () => {
    this.setState({ open: !this.state.open });
  };
  handleAction = (link) => {
    //   console.log('====================================');
    //   console.log({link}, link.sub && !!this.state.openSub);
    //   console.log('====================================');
      if (link.sub) {
            this.setState({
                openSub: this.state.openSub == link.name ? "" : link.name 
            })
        } else {
            this.props.changePage(link.name)
        }
  };


  render() {
    const { classes, theme, menu } = this.props;
    const { openSub} = this.state;

    // console.log('=================state SIDE BAR===================');
    // console.log(this.state);
    // console.log('====================================');
    return (
        <Box className="min-height" >
        {/* <Box name={page} {...this.props} className="min-height" > */}
            <div className={classes.root}>
                <CssBaseline />
                
                <Drawer
                    variant="permanent"
                    className={
                        classNames(classes.drawer, {
                            [classes.drawerOpen]: this.state.open,
                            [classes.drawerClose]: !this.state.open,
                        })
                    }
                    classes={{
                        paper: classNames({
                            [classes.drawerOpen]: this.state.open,
                            [classes.drawerClose]: !this.state.open,
                        }),
                    }}
                    open={this.state.open}
                >
                    <div >
                        <IconButton onClick={this.handleDrawer}>
                            {this.state.open ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                        </IconButton>
                    </div>
                    <Divider />
                    <List>

                    {menu.map(link => (
                        <Fragment key={link.name}>
                            <ListItem 
                                button 
                                onClick={() => this.handleAction(link)}
                                selected={this.props.page === link.name} 
                            >
                                <ListItemIcon >{link.icon}</ListItemIcon>
                                <ListItemText >
                                    {link.title}
                                </ListItemText>
                                {link.sub && (!openSub || openSub !== link.name ) && <ChevronRightOutlined /> }
                                {link.sub && openSub === link.name && <ExpandMoreRounded /> }
                            </ListItem>
                            {link.sub &&
                                <Collapse in={openSub == link.name} timeout="auto" unmountOnExit>
                                    <List component="div" disablePadding>
                                        {link.sub.map(sub => (
                                            <ListItem 
                                                button 
                                                className={classes.nested}
                                                key={sub.name}
                                                onClick={() => this.handleAction(sub)}
                                                selected={this.props.page === sub.name} 
                                            >
                                                {/* <ListItemIcon >
                                                    <IconButton>
                                                        <Adjust fontSize="small"/>
                                                    </IconButton>
                                                </ListItemIcon> */}
                                                <ListItemText >
                                                    {sub.title}
                                                </ListItemText>
                                            </ListItem>
                                        ))}
                                    </List>
                                </Collapse>
                            }
                        </Fragment>
                    ))}
                    </List>
                    
                </Drawer>
                <main className={classes.content + " container-height"}>
                    <Container maxWidth="xl">
                        {this.props.children}
                    </Container>
                </main>
            </div>
        </Box>
      
    );
  }
}

SideBar.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(SideBar);

// class SideBar extends Component {
//     state = {  }
//     render() {
//         // const colorClass = this.props.blue ? "admin-sidebar-b" : "admin-sidebar"
//         return (
//             <div>
//                 <div className="row admin-layout">
//                     <div className={"admin-sidebar " + (this.props.blue && "admin-sidebar-b") }>
//                         {this.props.children[0]}
//                     </div>
//                     <div className="admin-content">
                        
//                         {this.props.children[1]}
                        
//                     </div>
//                 </div>
//             </div>
               
//         );
//     }
// }

// export default SideBar;


class CardContent extends Component{

    render(){
        return(
            <div style={{padding:'5px 26px'}}>
                <div className="card-text" style={{ padding:"5px"}}>
                    {this.props.children}
                </div>
            </div>
        )
    }
}